import { Injectable, EventEmitter } from '@angular/core';

declare var $: any;
declare var Utility: any;
declare var __culture: string;
declare var isInfoBarOpen: boolean;

@Injectable()
export class MasterComponentService {

    public rightBarComponentName: string;

    public leftBarToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

    public nextStationClick: EventEmitter<any> = new EventEmitter<any>();
    public nextBusClick: EventEmitter<any> = new EventEmitter<any>();


    detailsChanged: EventEmitter<any> = new EventEmitter<any>();

    toggleRigthBar(): void {


        $(".infobar-wrapper").removeClass("closed");



        if ($(window).width() >= 992) {
            setTimeout(() => {
                $(".demo-options").css({ "right": "87px" })
            }, 300);
        }

    }

    closeRigthBar(): void {

        if (__culture != "ar") {
            $(".infobar-wrapper").addClass("closed");
        }
        else {
            $(".infobar-wrapper").addClass("closed");
            //$(".infobar-wrapper").css({
            //    "transform": "translate(59px, 0px)",
            //    'webkit-transform': 'translate(-590px, 0px)',
            //    '-ms - transform': 'translate(-590px, 0px)',
            //    '-o - transform': 'translate(-590px, 0px)'
            //});
        }

        if ($(window).width() >= 992) {
            $(".demo-options").css({ "right": "-198px" });
        }
    }

    toggleLeftBar(): void {

        Utility.toggle_leftbar();
        this.leftBarToggled.emit(true);
    }

    OpenHeaderBar(event: any): boolean {

        $('#headerbar').css('top', 0);

        $('html').one('click', function () {
            $('#headerbar').css('top', '-1000px');
        });

        event.stopPropagation();

        return false;
    }

    OpenFullScreenMode(): void {

        Utility.toggle_fullscreen(document.documentElement);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/master-component.service.ts